itsoftApp.createModule("scrollEffects", ["windowResize", "windowScroll"], function () {
    var module = this;
    var body = document.body;

    function ScrollEffect (self, classAnimate, oldClass) {
        this._self = self;
        this._classAnimate = classAnimate;
        this._oldClass = oldClass;
        this._scrollPoint;
        this._position = "bottom";
        this._get = window.innerHeight;
        if (this._self.hasAttribute("data-position")) {
            this._position = this._self.getAttribute("data-position");
        }
        this.init();
    }

    ScrollEffect.prototype.calculateValue = function () { //cb
        if (this._position === "middle") {
            this._positionValue = window.innerHeight / 2;
        } else if (this._position === "0.75") {
            this._positionValue = window.innerHeight * 0.75;
        } else if (this._position === "top") {
            this._positionValue = 0;
        } else {
            this._positionValue = window.innerHeight;
        }

        return this._positionValue;
    };

    ScrollEffect.prototype.init = function () {
        var self = this;

        self._check = function () { //scroll
            var scrolled = pageYOffset;
            // var coeff;

            self._scrollPoint = parseInt(self._self.getBoundingClientRect().top);

            if (scrolled + self.calculateValue() >= self._scrollPoint + scrolled) { /* NOTE: Если равен 0, элемент, скорее всего, скрыт display: none*/
                self.start();
            }
        };

        module.scrollEffectElements.push(self);

        self._check();

        itsoftApp.modules.windowScroll.addEvent(self._check);
    };

    var removeOldClass = function (obj) {
        obj._self.classList.remove(obj._oldClass);
        if (obj._classAnimate) {
            obj._self.classList.add(obj._classAnimate);
        }
        obj._oldClass = undefined;
    };

    var processing = false;

    ScrollEffect.prototype.start = function () {
        /* проверяем, дошли ли мы до нужного элемента */
        /* если да, выполняем метод start */
        if (this._oldClass && !processing) {
            processing = true;
            
            /* Ленивая загрузка скриптов */
            if (this._self.classList.contains("js-scroll-trigger") && this._self.classList.contains("js-invisible")) {
                if (this._self.classList.contains("js-scroll-anchor-start")) {
                    removeOldClass(this);
                    itsoftApp.modules.scrollActions.callback(this._self);
                }

                if (this._self.classList.contains("js-scroll-text-start")) {
                    removeOldClass(this);
                    itsoftApp.modules.scrollActions.callback(this._self);
                }
            }

            if (this._self.classList.contains("js-tabs-section") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
                itsoftApp.modules.toggleTabs.callback.init(this._self);
            }

            if (this._self.classList.contains("js-validation") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
                itsoftApp.modules.formsValidation.callback(this._self);
            }

            if (this._self.classList.contains("js-tabs-section") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
                console.log("scrollTabs")
                itsoftApp.modules.toggleTabs.callback.init(this._self);
            }

            if (this._self.classList.contains("js-select") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
                itsoftApp.modules.select.callback(this._self);
            }

            if (this._self.classList.contains("js-number-section") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
                itsoftApp.modules.numbersAnimate.init(this._self);
            }

            if (this._self.classList.contains("page__fw-700") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
                body.classList.add("page--fw-700");
            }

            processing = false;
        }
    };


    module.ScrollEffect = ScrollEffect;
    module.scrollEffectElements = [];
});
